import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { ExcelService, PurchaseReportService } from '../../../services/index';

@Component({
  selector: 'purchaseOrder',
  host: { '(window:keydown)': 'hotkeys($event)' },
  templateUrl: './agentWiseReport.html',
})
export class AgentWiseReport implements OnInit {
  @Input('tabTitle') title: string;
  @Input() active = false;

  gridOptions: any;
  isLoadMask: Promise<any>;
  loadingIndicator = true;
  filter = {
    groupby: 'agent_id',
    from_date: '',
    to_date: '',
    agent_name: '',
    party_code: ''
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: 'design_no',
    orderDir: 'asc',
  };
  printConfig: any = {
    title: 'Agent Wise Purchase Report',
    columns: [],
    rows: [],
  };

  @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
  @ViewChild('filterPanel') filterPanel;

  columns = [];
  toggleCol = [];
  orderList: any = [];
  exceldata: any;
  oneMonthBeforeDate: any;
  currentDate: any;
  defaultParams: any;
  backbutExists = false;

  constructor(private excelService: ExcelService, private purReport: PurchaseReportService,
    public datePipe: DatePipe) {
      const date = new Date();
      this.oneMonthBeforeDate = date.setMonth(date.getMonth() - 1);
      this.filter.from_date = this.oneMonthBeforeDate;
      this.currentDate = new Date();
      this.filter.to_date = this.currentDate;
    }

  ngOnInit(): void {
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [];
    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);
    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $('#party_code').focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($('.swal2-container').length > 0) {
      return false;
    } else {
      const a = $('.mat-autocomplete-panel.mat-autocomplete-visible');
      a.removeClass('mat-autocomplete-visible');
      $('#' + nextEl).focus();
    }
  }

  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  //  Called whenever the user changes page
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getOrderList();
  }

  //  Called whenever the user changes the sort order
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
  }

  applyFilter(): void {
    this.filterPanel.close();
    this.getOrderList();
  }

  onbackbutton() {
    this.defaultParams = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: '1',
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`
    };
    if (this.filter.groupby === 'type, width') {
      this.filter.groupby = 'party_id';
      this.defaultParams.filter = JSON.stringify(this.filter);
    } else if (this.filter.groupby === 'party_id') {
      this.filter.groupby = 'agent_id';
      this.defaultParams.filter = JSON.stringify(this.filter);
    }
    this.getOrderList();
  }

  backbutton() {
    if ($('.data-history-btn').length) {
      this.backbutExists = false;
    } else {
      this.backbutExists = true;
    }
  }

  getOrderList(): void {
    this.filter.from_date = this.datePipe.transform(
      this.filter.from_date,
      'yyyy-MM-dd'
    );
    this.filter.to_date = this.datePipe.transform(
      this.filter.to_date,
      'yyyy-MM-dd'
    );
    const params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: '1',
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter)
    };
    const that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };
    if (this.defaultParams === undefined) {
      this.isLoadMask = this.purReport.getAgentWiseReport(params)
        .then(function (res: any) {
          that.page.count = res.totCnt;
          that.orderList = res.data;
          that.gridOptions = {
            cols: res.cols,
            columns: res.columns,
            data: res.data,
            loading: false,
          };
          that.printConfig = {
            title: 'Agent Wise Purchase Report',
            columns: res.columns,
            rows: that.orderList,
          };
          that.exceldata = that.getData(res.columns, res.data);
        });
    } else {
      this.isLoadMask = this.purReport.getAgentWiseReport(this.defaultParams)
        .then(function (res: any) {
          that.page.count = res.totCnt;
          that.orderList = res.data;
          that.gridOptions = {
            cols: res.cols,
            columns: res.columns,
            data: res.data,
            loading: false,
          };
          that.printConfig = {
            title: 'Agent Wise Purchase Report',
            columns: res.columns,
            rows: that.orderList,
          };
          that.exceldata = that.getData(res.columns, res.data);
          that.backbutton();
        });
        that.loadingIndicator = false;
        this.defaultParams = undefined;
    }
  }

  onCellClick(event) {
    this.filter.agent_name = event.row.agent_name;
    this.defaultParams = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: '1',
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`
    };
    if (event.row.party_code === undefined) {
      this.filter.groupby = 'party_id';
      this.defaultParams.filter = JSON.stringify(this.filter);
    } else {
      this.filter.groupby = 'type, width';
      this.filter.party_code = event.row.party_code;
      this.defaultParams.filter = JSON.stringify(this.filter);
    }
    this.getOrderList();
  }

  getData(columns, data) {
    const cols = columns;
    const rows = [];
    let row;
    const clen = columns.length;
    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      const newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        const prop = cols[j].prop,
              name = cols[j].name;
        newrow[name] = row[prop];
      }
      rows.push(newrow);
      sno++;
    }
    return rows;
  }

}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/agentWiseReport/agentWiseReport.ts